export enum TipoGraficoEnum {
    ESTACAO_METEOROLOGICA = 'Estação Meteorológica/Equilíbrio Higroscópico',
    TEMPERATURA_INTERNA = 'Temperatura Interna',
    UMIDADE_RELATIVA_INTERNA = 'Umidade Relativa Interna',
}
